/**
 * Central config for merchant onboarding flow under /onboarding.
 * Add or reorder stages here; routes and screen navigation use this as single source of truth.
 */
export const MERCHANT_ONBOARDING_BASE = '/onboarding';

/** Ordered path segments (route paths relative to MERCHANT_ONBOARDING_BASE). */
export const MERCHANT_ONBOARDING_STAGE_SEGMENTS = [
  'administrative_billing_details_submitted',
  'contract_signed',
  'payment',
];

/**
 * @param {string} pathSegment - Current stage segment (e.g. 'administrative_billing_details_submitted', 'contract_signed')
 * @returns {string|null} Full path for next stage, or null if current is last
 */
export function getNextOnboardingPath(pathSegment) {
  const i = MERCHANT_ONBOARDING_STAGE_SEGMENTS.indexOf(pathSegment);
  if (i < 0 || i >= MERCHANT_ONBOARDING_STAGE_SEGMENTS.length - 1) return null;
  const next = MERCHANT_ONBOARDING_STAGE_SEGMENTS[i + 1];
  return `${MERCHANT_ONBOARDING_BASE}/${next}`;
}

/**
 * @param {string} pathSegment - Current stage segment
 * @returns {string|null} Full path for previous stage, or null if current is first
 */
export function getPrevOnboardingPath(pathSegment) {
  const i = MERCHANT_ONBOARDING_STAGE_SEGMENTS.indexOf(pathSegment);
  if (i <= 0) return null;
  const prev = MERCHANT_ONBOARDING_STAGE_SEGMENTS[i - 1];
  return `${MERCHANT_ONBOARDING_BASE}/${prev}`;
}

/** Full path of the first stage (for redirect from /onboarding/merchant). */
export const MERCHANT_ONBOARDING_FIRST_PATH = `${MERCHANT_ONBOARDING_BASE}/${MERCHANT_ONBOARDING_STAGE_SEGMENTS[0]}`;
